import {getCookie, setCookie} from "../../../core/helpers/cookieHelper";
import $ from "jquery";

export const bindClickEventsForDataLayerMetrics = () => {
    if (getCookie('ymUserParams') === undefined) {
        dataLayerPush('ym_user_params', {
            'ym_user_params': window.ym_user_params,
            'email': window.ym_user_params_email || null
        });

        setCookie('ymUserParams', true, {'max-age': 86400});
    }

    $(document).on('click', '.social-authorization__link--fb', function () {
        dataLayerPush('login_platform', {'login_platform': 'facebook_login'});

        return true;
    });

    $(document).on('click', '.social-authorization__link--google', function () {
        dataLayerPush('login_platform', {'login_platform': 'google_login'});

        return true;
    });

    $(document).on('click', '.social-authorization__link--vk', function () {
        dataLayerPush('login_platform', {'login_platform': 'vk_login'});

        return true;
    });

    $(document).on('click', '#signin-button-form', function () {
        dataLayerPush('login_platform', {'login_platform': 'email_login'});

        return true;
    });

    $(document).on('click', '#header-in-out__logout-btn', function () {
        dataLayerPush('logout');
    });

    $(document).on('click', '.header-in-out header-in-out__profile', function () {
        dataLayerPush('sign_in');
    });

    $(document).on('click', '.comment-reply__send', function () {
        dataLayerPush('comment');

        return true;
    });

    $(document).on('click', '.tabs__item:eq(0)', function () {
        dataLayerPush('comment_sort', {'comment_sort': 'sort_popular'});

        return true;
    });

    $(document).on('click', '.tabs__item:eq(1)', function () {
        dataLayerPush('comment_sort', {'comment_sort': 'sort_new'});

        return true;
    });

    $(document).on('click', '.tabs__item:eq(2)', function () {
        dataLayerPush('comment_sort', {'comment_sort': 'sort_old'});

        return true;
    });

    $(document).on('click', '.comment-actions__item-edit', function () {
        dataLayerPush('comment_interaction', {'comment_interaction': 'edit_comment'});

        return true;
    });

    $(document).on('click', '.comment-actions__item-delete', function () {
        dataLayerPush('comment_interaction', {'comment_interaction': 'del_comment'});

        return true;
    });

    $(document).on('click', '.comment-actions__item-complain', function () {
        dataLayerPush('comment_interaction', {'comment_interaction': 'complain_comment'});

        return true;
    });

    $(document).on('click', '.modal-form__link-forgot-password', function () {
        dataLayerPush('forgot_pass');

        return true;
    });

};
export const shareFbBtnHandler = () => {
    dataLayerPush('social_platform', {'social_platform': 'facebook_share'});
};
export const shareVkBtnHandler = () => {
    dataLayerPush('social_platform', {'social_platform': 'vk_share'});
};
export const shareTwitterBtnHandler = () => {
    dataLayerPush('social_platform', {'social_platform': 'twitter_share'});
};
export const shareTelegramBtnHandler = () => {
    dataLayerPush('social_platform', {'social_platform': 'telegram_share'});
};
export const quizShareFbBtnHandler = () => {
    dataLayerPush({'quiz_sharing': 'fb_share_test'});
};
export const quizShareVkBtnHandler = () => {
    dataLayerPush('social_platform', {'quiz_sharing': 'vk_share_test'});
};
export const quizShareTwitterBtnHandler = () => {
    dataLayerPush('social_platform', {'quiz_sharing': 'twitter_share_test'});
};
export const quizShareTelegramBtnHandler = () => {
    dataLayerPush('social_platform', {'quiz_sharing': 'telegram_share_test'});
};
export const shareWhatsappBtnHandler = () => {
    dataLayerPush('social_platform', {'social_platform': 'whatsapp_share'});
};
export const partnerHandler = () => {
    dataLayerPush('partners_widget_visibility');
};
export const eternalGetNextHandler = () => {
    dataLayerPush('infinite_scroll');
};
export const registrationHandler = () => {
    dataLayerPush('registration');

    return true;
};
export const mkSubscribe = (button, title) => {
    if (button.is('.subscription-btn--active')) {
        dataLayerPush('unsubscribe', {'unsubscribe': title});
    } else {
        dataLayerPush('subscribe', {'subscribe': title});
    }
};
export const commentHandler = () => {
    dataLayerPush('comments_widget_visibility');
};

export const bookmakerAddHandler = (id) => {
    dataLayerPush('analyticsEvent', {
        "eventAction": "bookmark_add",
        "eventCategory":"content",
        "eventLabel": id,
        "eventProperty": "",
        "eventValue": ""
    });
};

export const crossRecommenderViewHandler = (label, model) => {
    dataLayerPush('analyticsEvent', {
        "eventAction": "view",
        "eventCategory":"recs",
        "eventLabel": label,
        "eventProperty": "",
        "eventValue": model
    });
};

export const crossRecommenderClickHandler = (id, type, label, model) => {
    dataLayerPush('analyticsEvent', {
        "eventAction": "click",
        "eventCategory":"recs",
        "eventLabel": label,
        "eventProperty": {"page_type": type, "page_id": id},
        "eventValue": model
    });
};

export const crossRecommenderGetListHandler = (label, model) => {
    dataLayerPush('analyticsEvent', {
        "eventAction": "request",
        "eventCategory":"recs",
        "eventLabel": label,
        "eventProperty": "",
        "eventValue": model
    });
};

export const bookmakerRemoveHandler = (id) => {
    dataLayerPush('analyticsEvent', {
        "eventAction": "bookmark_remove",
        "eventCategory":"content",
        "eventLabel": id,
        "eventProperty": "",
        "eventValue": ""
    });
};

const dataLayerPush = (event, params) => {
    window.dataLayer = window.dataLayer || [];

    const pushParams = params || {};
    pushParams['event'] = event;
    console.info(pushParams);
    window.dataLayer.push(pushParams);
};
